import Button from 'src/app/components/Elements/Button';
import { PhoneNumber } from 'src/app/components/Elements/Location/PhoneNumber';
import { clearNetworkErrors } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';

import styles from './styles.module.scss';
import { getCustomApiFlavorText } from './utils';

/**
 * This is a generic error alert that should occur if any error happens which we don't know how to handle
 */
export interface CustomApi {
  title?: string;
  flavorText: any; // Flavor text can be objects.
  errorCode: number | string;
  silent: boolean;
  canDismiss: boolean;
}

interface ErrorAlertProps {
  customApi: CustomApi;
  genericError: boolean;
  networkConnectivityError: boolean;
}

export const UnconnectedErrorAlert = ({ customApi, genericError, networkConnectivityError }: ErrorAlertProps) => {
  const dispatch = useDispatch();
  const reload = () => location.reload();

  const handleOnExit = () => {
    dispatch(clearNetworkErrors());
  };

  return (customApi || genericError || networkConnectivityError) && !customApi?.silent ? (
    <div className={styles.component} data-cy="error-alert">
      <div className={styles.overlay} />
      <div className={styles.alertBox}>
        {genericError && (
          <>
            <h1>Oops, looks like something went wrong.</h1>
            <p>
              Please reload the page, or contact us at <PhoneNumber /> for further assistance.
            </p>
          </>
        )}
        {networkConnectivityError && (
          <>
            <h1>Internet connectivity error</h1>
            <p>
              Please check your internet connection and then reload the page,
              <br /> or contact us at <PhoneNumber /> for further assistance.
            </p>
          </>
        )}
        {customApi && (
          <>
            <h1>{customApi.title ? customApi.title : 'Oops, looks like something went wrong.'}</h1>
            <p>{getCustomApiFlavorText(customApi)}</p>
          </>
        )}
        <div className={styles.actions}>
          <Button className="ml-4" size="small" onClick={reload}>
            Reload
          </Button>
          {!customApi?.canDismiss ? (
            <a href="/rx/contact">
              <Button size="small" onClick={handleOnExit}>
                Contact Us
              </Button>
            </a>
          ) : (
            <Button size="small" onClick={handleOnExit}>
              Dismiss
            </Button>
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
